<template>
    <my-page :loading="isLoading">
        <template #heading>{{ title }}</template>

        <plan-comparison />

        <sideloading-options v-if="!hasPremium && !premiumUnavailable" :options="premiumOptions" hide-name
            targetUrl="/my/premium" />
        <html-with-links v-else-if="hasPremium" class="g-text toast" tag="p"
            :html="$t('YOU_ALREADY_HAVE_PREMIUM', { subscriptionsLink: '/my/billing' })" />
        <html-with-links v-else class="g-text toast" tag="p" :html="$t('PREMIUM_CURRENTLY_UNAVAILABLE')" />

        <html-with-links class="description g-text" :html="$t('PREMIUM_FEATURES_DESC')"></html-with-links>

        <template #sidebar></template>
    </my-page>
</template>

<script>
import { mapGetters } from 'vuex';
import MyPage from './components/MyPage.vue';
import HtmlWithLinks from '../../components/HtmlWithLinks.vue';
import SideloadingOptions from '@/components/SideloadingOptions.vue';
import PlanComparison from '@/components/PlanComparison.vue';

export default {
    components: {
        MyPage,
        SideloadingOptions,
        HtmlWithLinks,
        PlanComparison,
    },
    data() {
        return {
            isLoading: true,
            premiumOptions: [],
        };
    },
    computed: {
        ...mapGetters(['hasPremium']),
        title() {
            return `${this.BRAND_CONFIG.name} PREMIUM`;
        },
        premiumUnavailable() {
            return this.$store.state.stats.premium_slots_available === 0;
        }
    },
    created() {
        Promise.all([
            this.$api.getSideloadingOptions('premium')
                .then((response) => {
                    this.premiumOptions = response;
                }),
            this.$store.dispatch('getStats')
        ]).finally(() => {
            this.isLoading = false;
        });
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.content {
    margin-bottom: 25px;
}

.toast {
    background-color: var(--secondary-bg);
    padding: 10px;
    border-radius: 8px;
}

.description {
    margin-top: 25px;

    &::v-deep {
        p+p {
            margin-top: 5px;
        }
    }
}
</style>